/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

function ChangePasswordModalController(this: JS5Object, _: JS5Object, UsersService: JS5Object, NotificationService: JS5Object) {
    this.currentPasswordInput = '';
    this.passwordInput = '';
    this.retypedPasswordInput = '';
    this.passwordInputValid = false;
    this.retypedPasswordInputValid = false;
    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        UsersService.getPasswordRequirements().then((passwordRequirements: JS5Object) => {
            this.passwordRequirements = passwordRequirements;
        });
    };

    this.retypedPasswordRequirements = [{
        getDescription: () => {
            let thisRequirement = this.retypedPasswordRequirements[0];
            if (thisRequirement.isValid()) {
                return `Passwords match`;
            } else if (thisRequirement.isWarning()) {
                return `Passwords empty`;
            } else {
                return `Passwords don't match`;
            }
        },
        isValid: () => this.passwordInput === this.retypedPasswordInput && !!this.passwordInput.length,
        isWarning: () => !this.passwordInput.length && !this.retypedPasswordInput.length
    }];

    this.onDone = (): void => {
        UsersService.updatePassword(this.currentPasswordInput, this.passwordInput).then(() => {
            NotificationService.createSuccessNotification('Password updated successfully');
            this.close({
                $value: true
            });
        }).catch((error: JS5Object) => {
            NotificationService.createFailureNotification(_.get(error, 'data.validationErrors[0].message'));
        });
    };
    this.doneEnabled = () => {
        return !_.isEmpty(this.currentPasswordInput) && this.passwordInputValid && this.retypedPasswordValid && _.isEqual(this.passwordInput, this.retypedPasswordInput);
    };
}

angular
    .module('prism-ui.components')
    .component(
        'changePasswordModal',
        {
            controller: ChangePasswordModalController,
            templateUrl: 'components/modal/security/changePasswordModal/change-password-modal-template.html',
            bindings: {
                resolve: '<',
                close: '&',
                dismiss: '&'
            }
        }
    );
